export interface SolutionStep {
    transitions:string[];
    shift:number;
}

export interface Solution {
    steps:SolutionStep[];
}

export enum ProblemSection {
    limits = "limits",
    derivatives = "derivatives",
    integrals = "integrals"
}

export enum MathPartTypes {
    tag = 'tag',
    math = 'math',
    text = 'text',
    grl = 'grl',
}

export class MathPart {
    t: MathPartTypes;
    v: string;

    constructor(type: MathPartTypes, value: string) {
        this.t = type;
        this.v = value;
    }
}
export interface Problem {
    seed: number;
    statement: MathPart[];
    answersGrl: string[];
    solutions: Solution[];
    topicId: string;
    section: ProblemSection;
}

export interface StudentSolution {
    //solution: MathPart[];
    id: string;
    answersInternal: string[];

    checkAnswerCount: number;
    hintRequested: boolean;
    //solutionViewed: boolean;
    solutionStepsViewed:number;
    solved: boolean|undefined;

    inHistory: boolean;
}

export interface StudentHistoryRecord {
    topicId:string;
    section: ProblemSection;
    seed:number;

    checkAnswerCount:number;
    hintRequested:boolean;
    //solutionViewed:boolean;
    solutionStepsViewed:number;
    solved:boolean;
}

export interface ProblemState {
    problem?:Problem;
    studentSolution?:StudentSolution;
    history: StudentHistoryRecord[];
}

export interface SectionedTopic {
    section:ProblemSection;
    id:string;
    description:string;
    title:string;
}

export interface TopicState {
    topics:SectionedTopic[];
}



export interface RootState {
    problemState:ProblemState;
    topicState:TopicState;
}
